
const addAssignLicensesModalId = ( teamId = 0 ) => {
    return `msync-org-assign-licenses-modal-${teamId}`
}

export {
    addAssignLicensesModalId
}
